module.exports = __webpack_public_path__ + "img/1B.3cbdd53f.jpg";